import { cameraModelsSelector } from 'selectors'
import { select } from 'redux-saga/effects'
import propEq from 'ramda/src/propEq'

export default function * getModelFromPath(modelPath) {
  const { cameraModels } = yield select(cameraModelsSelector)
  return cameraModels.find(propEq('model_path', modelPath))
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/getModelFromPath.js